import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import type { User } from "@/context/UserProvider";
import { useTheme } from "@/components/ui/theme-provider";
import { Button } from "@/components/ui/button";
import { Moon, Sun, FileText } from "lucide-react";
import { useMunicipality } from "@/context/MunicipalityContext";
import { documentManagementFlagged } from "@/lib/adminSettings";

interface AccountDialogProps {
  user: User;
  open: boolean;
  onOpenChange: (open: boolean) => void;
  onManageDocuments: () => void;
}

function AccountDialog({ user, open, onOpenChange, onManageDocuments }: AccountDialogProps) {
  const { setTheme } = useTheme();
  const { municipality } = useMunicipality();
  const showManageDocuments = !documentManagementFlagged(municipality);

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>Account Settings</DialogTitle>
        </DialogHeader>
        <div className="space-y-4">
          <div>
            <p className="text-sm text-muted-foreground">Email</p>
            <p className="font-medium">{user.email}</p>

            {showManageDocuments && (
              <div className="mt-4">
                <p className="text-sm text-muted-foreground mb-2">Documents</p>
                <Button
                  variant="outline"
                  className="w-full justify-start"
                  onClick={() => {
                    onOpenChange(false);
                    onManageDocuments();
                  }}
                  disabled={!municipality}
                >
                  <FileText className="h-5 w-5" />
                  <span className="ml-2">Manage Documents</span>
                </Button>
                {!municipality && (
                  <p className="text-xs text-muted-foreground mt-1">
                    Please select a municipality to manage documents
                  </p>
                )}
              </div>
            )}

            <div className="mt-4">
              <p className="text-sm text-muted-foreground mb-2">Theme</p>
              <div className="grid grid-cols-2 gap-2">
                <Button
                  variant="ghost"
                  className={"w-full justify-start"}
                  onClick={() => setTheme("light")}
                >
                  <Sun className="h-5 w-5" />
                  <span className="ml-2">Light</span>
                </Button>
                <Button
                  variant="ghost"
                  className={"w-full justify-start"}
                  onClick={() => setTheme("dark")}
                >
                  <Moon className="h-5 w-5" />
                  <span className="ml-2">Dark</span>
                </Button>
              </div>
            </div>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
}
export default AccountDialog;
